<template>
  <v-app>
    <Navigations :breadcrumbs="this.breadcrumb" />
    <v-main class="bg-white">
      <v-container>
        <v-row class="py-15">
      
          <v-col cols="12">
            <v-card elevation="0" class="pa-3 text-center">
              <v-row>
                <v-col offset-md="2" cols="12" md="8">
              <h1>Hulp nodig?</h1>
              <p>
                Heb je een vraag over een Kyano product? Neem dan even een kijkje in
                onze kennisbank. Heb je geen antwoord kunnen vinden, neem dan
                contact met ons op.
              </p>
              </v-col>
              <v-col offset-md="3" cols="12" md="6">
                  <v-img
                  width="300"
                  class="m-auto text-center"
                  src="../assets/illustrations/support.svg"
                ></v-img>
                <br>
                <h4>Chat met een medewerker.</h4>
                <v-btn color="secondary" elevation="0" class="text-center mx-auto" href="">Start een gesprek</v-btn>
              </v-col>
              </v-row>
            </v-card>

          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<script>
import Navigations from '../components/Navigations.vue';

export default {
  components: {
    Navigations,
  },

  data: () => ({
    breadcrumb: [
      {
        text: "Support",
        disabled: true,
        href: "/support",
      },
    ],
  }),
};
</script>
